<template>
  <div class="site-detail-area">
    <h3>送信先</h3>
    <div class="table-format">
      <div class="table-format-header column-order-email-list">
        <div>メールアドレス</div>
        <div>宛名</div>
        <div>送信種別</div>
        <div>
          <button class="add-button" @click.prevent="addList(orderEmailList)">追加</button>
        </div>
      </div>
      <div class="table-format-body-row column-order-email-list" v-for="(item, index) in orderEmailList" :key="index">
        <input type="text" min="0" :name="'orderEmailList[' + index + '][email]'" v-model="item.email" />
        <input type="text" min="0" :name="'orderEmailList[' + index + '][name]'" v-model="item.name" />
        <select :name="'orderEmailList[' + index + '][send_div]'" v-model="item.send_div">
          <option :value="id" v-for="(label, id) in enumSendDiv" :key="id">
            {{ label }}
          </option>
        </select>

        <div class="button-wrapper">
          <button class="delete-button" @click.prevent="deleteItem(orderEmailList, index)">削除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const orderEmailList = ref(data.orderEmailList);
const enumSendDiv = data.enum.SendDiv;

onMounted(() => {
  //エラー項目を赤くする
  for (const [key, message] of Object.entries(data.errorMessages)) {
    const name = key.replace(/\.(\w+)/g, '[$1]');
    document.getElementsByName(name).forEach((element) => {
      const isDisplayMessage = element.dataset.displayMessage ?? false;
      if (isDisplayMessage) {
        const messageElement = document.createElement('span');
        messageElement.textContent = message;
        messageElement.classList.add('invalid-feedback');
        element.insertAdjacentElement('afterend', messageElement);
      }
      element.classList.add('is-invalid');
    });
  }
});

const addList = (targetList) => {
  targetList.push({});
};

const deleteItem = (targetList, index) => {
  targetList.splice(index, 1);
};
</script>

<style lang="scss">
/* Excel風テーブルスタイル */
:root {
  --excel-border: #d0d7de;
  --excel-header-bg: #f2f4f8;
  --excel-header-text: #1f2328;
  --excel-cell-bg: #ffffff;
  --excel-cell-hover: #f6f8fa;
  --excel-cell-focus: #ddf4ff;
  --excel-green: #107c41;
  --excel-shadow: rgba(0, 0, 0, 0.08);
}

.site-detail-area {
  h3 {
    margin: 0;
  }

  .table-format {
    background: var(--excel-cell-bg);
    border: 1px solid var(--excel-border);
    border-radius: 4px;
    overflow: hidden;
    max-width: 100%;
    overflow-x: auto;
    margin-bottom: 30px;
  }

  /* ヘッダー */
  .table-format-header {
    display: grid;
    background: var(--excel-header-bg);
    border-bottom: 1px solid var(--excel-border);
    font-weight: 600;
    font-size: 13px;
    color: var(--excel-header-text);
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .column-order-email-list {
    grid-template-columns: 1fr 1fr 120px 50px;
    min-width: 730px;
  }

  .table-format-header > div {
    padding: 5px;
    border-right: 1px solid var(--excel-border);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: linear-gradient(180deg, #f8f9fa 0%, #f2f4f8 100%);
  }

  .table-format-header > div:last-child {
    border-right: none;
  }

  /* ボディ */
  .table-format-body {
    background: var(--excel-cell-bg);
  }

  .table-format-body-row {
    display: grid;
    border-bottom: 1px solid var(--excel-border);
    transition: background-color 0.15s ease;
  }

  .table-format-body-row:hover {
    background-color: var(--excel-cell-hover);
  }

  .table-format-body-row:last-child {
    border-bottom: none;
  }

  .table-format-body-row > * {
    padding: 3px 3px;
    display: flex;
    align-items: center;
    font-size: 15px;
  }

  .table-format-body-row > *:last-child {
    border-right: none;
  }

  /* ドラッグアイコン */
  .drag-icon {
    cursor: grab;
    color: #8b949e;
    justify-content: center;
    background: #f6f8fa;
    border-right: 1px solid var(--excel-border);
    transition: all 0.2s ease;
  }

  .drag-icon:hover {
    color: var(--excel-header-text);
    background: #eaeef2;
  }

  .drag-icon:active {
    cursor: grabbing;
    background: #dde1e6;
  }

  .drag-icon i {
    font-size: 14px;
  }

  /* インプット */
  input[type='text'],
  select {
    width: 100%;
    padding: 6px 8px;
    border: 1px solid transparent;
    background: transparent;
    font-size: 15px;
    color: var(--excel-header-text);
    outline: none;
    border-radius: 2px;
    transition: all 0.15s ease;
    border-right: 1px solid var(--excel-border);
  }

  input[type='text']:hover {
    background: var(--excel-cell-hover);
    border-color: var(--excel-border);
  }

  input[type='text']:focus {
    background: var(--excel-cell-focus);
    border-color: #0969da;
    box-shadow: 0 0 0 2px rgba(9, 105, 218, 0.1);
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* ボタン */
  .add-button,
  .delete-button {
    padding: 2px 7px;
    border: 1px solid var(--excel-border);
    border-radius: 3px;
    font-family: inherit;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    width: 100%;
  }

  .add-button {
    background: var(--excel-green);
    color: white;
    border-color: var(--excel-green);
    box-shadow: 0 1px 2px rgba(16, 124, 65, 0.15);
  }

  .add-button:hover {
    background: #0e6b38;
    border-color: #0e6b38;
    box-shadow: 0 2px 4px rgba(16, 124, 65, 0.25);
    transform: translateY(-1px);
  }

  .add-button:active {
    background: #0c5a2e;
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(16, 124, 65, 0.15);
  }

  .delete-button {
    background: white;
    color: #cf222e;
    border-color: rgba(207, 34, 46, 0.2);
  }

  .delete-button:hover {
    background: #fff1f3;
    border-color: rgba(207, 34, 46, 0.4);
    transform: translateY(-1px);
    box-shadow: 0 1px 3px rgba(207, 34, 46, 0.15);
  }

  .delete-button:active {
    background: #ffe5e8;
    transform: translateY(0);
    box-shadow: none;
  }

  .button-wrapper {
    justify-content: center;
  }

  /* スクロールバーのスタイル（Webkit系ブラウザ） */
  .table-format::-webkit-scrollbar {
    height: 12px;
    background: #f6f8fa;
  }

  .table-format::-webkit-scrollbar-thumb {
    background: #d0d7de;
    border-radius: 6px;
    border: 2px solid #f6f8fa;
  }

  .table-format::-webkit-scrollbar-thumb:hover {
    background: #b4bcc4;
  }

  /* レスポンシブ調整 */
  @media (max-width: 1200px) {
    .table-format {
      border-radius: 0;
    }

    body {
      padding: 0;
    }
  }

  .table-format-body-row.selected > .drag-icon {
    background-color: #d0e8ff;
  }
}
</style>
